// eslint-disable-next-line import/no-default-export
export default {
    REDUCER_KEY: "BROKER",
    ENTITY_NAME: "broker",
    RESOURCE: "brokers",
};
